import confirm from '../../../utils/confirm.jsx';
import addError from '../../../utils/error.jsx';

export function request(id, accountId) {
    return confirm('Are you sure that you want to unsettle this bet?', {
        type: 'BETS_UNSETTLEMENT_REQUEST',
        accountId,
        id
    });
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'BETS_UNSETTLEMENT_ERROR',
        errors,
        id
    };
}

export function finish(id, data) {
    return {
        type: 'BETS_UNSETTLEMENT_FINISH',
        data,
        id
    };
}
